import { useTranslation } from 'react-i18next'

import {
  QA_NAME_CANCEL_BTN,
  QA_NAME_CLEAR_BTN,
  QA_NAME_SAVE_BTN,
} from '../../../../constants/qa'
import { getSelectedSize } from '../../../Table'
import { TableModal } from '../../../TableModal'
import {
  useDocFlowContext,
  useDocFlowSendingEpostValidationErrorsReportModal,
  useSendingTableMassActions,
} from '../../DocFlow.hooks'
import { DocFlowEpostValidationPreviewModal } from '../../DocFlowEpostValidationPreviewModal'
import { DocFlowSendingFieldName } from '../DocFlowSending.constants'

import { QA_NAME_DOC_FLOW_SENDING_EPOST_VALIDATION_ERRORS_REPORT_MODAL } from './DocFlowSendingEpostValidationErrorsReportModal.constants'
import {
  getDocFlowValidationErrorsModalColumns,
  getDocFlowValidationErrorsModalMassActions,
} from './DocFlowSendingEpostValidationErrorsReportModal.utils'
import { DocFlowSendingEpostValidationErrorsReportModalRow } from './DocFlowSendingEpostValidationErrorsReportModalRow'

import * as styles from './DocFlowSendingEpostValidationErrorsReportModal.module.css'

function DocFlowSendingEpostValidationErrorsReportModal({ errorIds, onClose }) {
  const { t } = useTranslation()

  const { handleCloseModal, setModal } = useDocFlowContext()

  const {
    emptyCommunicationRecipients,
    handleClickSubmit,
    handleCloseTableModal,
    handleToggleSaveToProfile,
    handleToggleSendAdditionalEmail,
    handleToggleSendEmail,
    isCloseConfirm,
    notifications,
    saveToProfile,
    selectionData,
    sendAdditionalEmail,
    sendEmail,
    setCloseConfirm,
    tableData,
  } = useDocFlowSendingEpostValidationErrorsReportModal({
    errorIds,
    onClose,
  })

  const {
    columns,
    handleSetOrdering,
    handleSetPagination,
    isLoading,
    isLoadingPage,
    items,
    ordering,
    pagination,
  } = tableData

  const preparedColumns = getDocFlowValidationErrorsModalColumns(columns)

  const massActions = getDocFlowValidationErrorsModalMassActions(t)

  const {
    checkIsItemSelected,
    exclude,
    handleExclude,
    handleSelect,
    handleSelectAll,
    handleSelectAllPages,
    handleUnselectAllPages,
    isAllSelected,
    isRemoveSelection,
    selectAllPages,
    selected,
  } = selectionData

  const { setMassAction } = useSendingTableMassActions({
    selectionData,
    usersTableData: tableData,
  })

  function handleOpenValidationPreview(item) {
    setModal(
      <DocFlowEpostValidationPreviewModal
        recipient={item[DocFlowSendingFieldName.Recipient]}
        sendingId={item.id}
        onClose={handleCloseModal}
      />
    )
  }

  return (
    <TableModal
      initialFullScreen
      Search={null}
      actionsProps={{
        buttonAttachProps: {
          isLoading: isLoadingPage,
          qaName: QA_NAME_SAVE_BTN,
          text: 'Modal.SaveBtnKey',
          onClick: handleClickSubmit,
        },
        buttonCancelProps: {
          qaName: QA_NAME_CANCEL_BTN,
          onClick: handleCloseTableModal,
        },
        buttonClearProps: {
          qaName: QA_NAME_CLEAR_BTN,
          onClick: handleUnselectAllPages,
        },
      }}
      contentProps={{ loading: isLoadingPage }}
      counterProps={{
        count: pagination?.count,
        text: 'DocFlow.EpostValidationErrorsModalCounterKey',
      }}
      headerProps={{
        text: 'DocFlow.EpostValidationErrorsModalTitleKey',
        onClose: handleCloseTableModal,
      }}
      isCloseConfirm={isCloseConfirm}
      isInitLoading={isLoading}
      massActions={massActions}
      massActionsProps={{
        isAllSelected,
        isRemoveSelection,
        selectedSize: getSelectedSize({
          exclude,
          pagination,
          selectAllPages,
          selected,
        }),
        setMassAction,
        onSelectAll: handleSelectAll,
      }}
      notifications={notifications}
      paginationProps={{ pagination, onChange: handleSetPagination }}
      qaName={QA_NAME_DOC_FLOW_SENDING_EPOST_VALIDATION_ERRORS_REPORT_MODAL}
      selectAllPages={selectAllPages}
      selected={selected}
      selectionToolbarProps={{
        exclude,
        pagination,
        selectAllPages,
        selected,
        onClose: handleUnselectAllPages,
        onSelectAll: handleSelectAllPages,
      }}
      setCloseConfirm={setCloseConfirm}
      tableItems={items?.items}
      tableProps={{
        TableRow: DocFlowSendingEpostValidationErrorsReportModalRow,
        checkIsItemSelected,
        className: styles.table,
        columns: preparedColumns,
        headerRowProps: {
          ordering,
          resizable: false,
          withCellBorder: false,
          onSetOrdering: handleSetOrdering,
        },
        items: items?.items,
        rowProps: {
          emptyCommunicationRecipients,
          saveToProfileIds: saveToProfile,
          sendAdditionalEmailIds: sendAdditionalEmail,
          sendEmailIds: sendEmail,
          onOpenValidationPreview: handleOpenValidationPreview,
          onSelect: selectAllPages ? handleExclude : handleSelect,
          onToggleSaveToProfile: handleToggleSaveToProfile,
          onToggleSendAdditionalEmail: handleToggleSendAdditionalEmail,
          onToggleSendEmail: handleToggleSendEmail,
        },
      }}
      onApplyConfirmModal={onClose}
      onClose={onClose}
      onTableModalClose={handleCloseTableModal}
    />
  )
}

export default DocFlowSendingEpostValidationErrorsReportModal
